import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.5 3.75C12.5 3.40482 12.7798 3.125 13.125 3.125H16.25C16.5952 3.125 16.875 3.40482 16.875 3.75V6.875C16.875 7.22018 16.5952 7.5 16.25 7.5C15.9048 7.5 15.625 7.22018 15.625 6.875V4.375H13.125C12.7798 4.375 12.5 4.09518 12.5 3.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.6919 3.30806C16.936 3.55214 16.936 3.94786 16.6919 4.19194L12.3169 8.56694C12.0729 8.81102 11.6771 8.81102 11.4331 8.56694C11.189 8.32286 11.189 7.92714 11.4331 7.68306L15.8081 3.30806C16.0521 3.06398 16.4479 3.06398 16.6919 3.30806Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 12.5C4.09518 12.5 4.375 12.7798 4.375 13.125V15.625H6.875C7.22018 15.625 7.5 15.9048 7.5 16.25C7.5 16.5952 7.22018 16.875 6.875 16.875H3.75C3.40482 16.875 3.125 16.5952 3.125 16.25V13.125C3.125 12.7798 3.40482 12.5 3.75 12.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.56694 11.4331C8.81102 11.6771 8.81102 12.0729 8.56694 12.3169L4.19194 16.6919C3.94786 16.936 3.55214 16.936 3.30806 16.6919C3.06398 16.4479 3.06398 16.0521 3.30806 15.8081L7.68306 11.4331C7.92714 11.189 8.32286 11.189 8.56694 11.4331Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.25 12.5C16.5952 12.5 16.875 12.7798 16.875 13.125V16.25C16.875 16.5952 16.5952 16.875 16.25 16.875H13.125C12.7798 16.875 12.5 16.5952 12.5 16.25C12.5 15.9048 12.7798 15.625 13.125 15.625H15.625V13.125C15.625 12.7798 15.9048 12.5 16.25 12.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.4331 11.4331C11.6771 11.189 12.0729 11.189 12.3169 11.4331L16.6919 15.8081C16.936 16.0521 16.936 16.4479 16.6919 16.6919C16.4479 16.936 16.0521 16.936 15.8081 16.6919L11.4331 12.3169C11.189 12.0729 11.189 11.6771 11.4331 11.4331Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.125 3.75C3.125 3.40482 3.40482 3.125 3.75 3.125H6.875C7.22018 3.125 7.5 3.40482 7.5 3.75C7.5 4.09518 7.22018 4.375 6.875 4.375H4.375V6.875C4.375 7.22018 4.09518 7.5 3.75 7.5C3.40482 7.5 3.125 7.22018 3.125 6.875V3.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.30806 3.30806C3.55214 3.06398 3.94786 3.06398 4.19194 3.30806L8.56694 7.68306C8.81102 7.92714 8.81102 8.32286 8.56694 8.56694C8.32286 8.81102 7.92714 8.81102 7.68306 8.56694L3.30806 4.19194C3.06398 3.94786 3.06398 3.55214 3.30806 3.30806Z"
		})
	]
});
export default SvgArrowsOut;
